import bundles from '@/data/bundles'

export const getBundle = (bundleGroupKey: string) => {
    return bundles.find(bundle => bundle.bundle_group_key === bundleGroupKey)
}